import { render, staticRenderFns } from "./PluginCode.vue?vue&type=template&id=626d0662&scoped=true"
import script from "./PluginCode.vue?vue&type=script&lang=js"
export * from "./PluginCode.vue?vue&type=script&lang=js"
import style0 from "./PluginCode.vue?vue&type=style&index=0&id=626d0662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626d0662",
  null
  
)

export default component.exports